import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { notification } from 'antd'
import { history } from 'index'
import * as jwt from 'services/keycloak'
import { snakeCase } from 'lodash'
import { setActiveTenant } from 'config/tenantRouting'
import actions from './actions'
import { idendify, resetSession } from '../../config/analytics'
import { getCurrentAccount, setCurrentAccount } from '../../services/accountService'

const mapAuthProviders = {
  jwt: {
    login: jwt.login,
    register: jwt.register,
    currentAccount: jwt.currentAccount,
    logout: jwt.logout,
  },
}

export function* LOGIN({ payload }) {
  const { email, password } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider: autProviderName } = yield select(state => state.settings)
  const success = yield call(mapAuthProviders[autProviderName].login, email, password)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Logged In',
      description: 'You have successfully logged in!',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* REGISTER({ payload }) {
  const { email, password, name } = payload
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider } = yield select(state => state.settings)
  const success = yield call(mapAuthProviders[authProvider].register, email, password, name)
  if (success) {
    yield put({
      type: 'user/LOAD_CURRENT_ACCOUNT',
    })
    yield history.push('/')
    notification.success({
      message: 'Succesful Registered',
      description: 'You have successfully registered!',
    })
  }
  if (!success) {
    yield put({
      type: 'user/SET_STATE',
      payload: {
        loading: false,
      },
    })
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: true,
    },
  })
  const { authProvider } = yield select(state => state.settings)
  try{
    const response = yield call(mapAuthProviders[authProvider].currentAccount)
    if (response) {
      setActiveTenant(response.tenant?.id)
      const { id, email, name, avatar, role, locale, ...rest } = response
      if(!rest.tenant.attivo){
        yield call(mapAuthProviders[authProvider].logout, {redirectUri: `https://performahrm.com`})
      }
      yield put({
        type: 'user/SET_STATE',
        payload: {
          id,
          name,
          email,
          avatar,
          role,
          locale,
          authorized: true,
          ...rest
        },
      })
      // multiaccount check
      const ca = getCurrentAccount()
      if(ca && rest.platformAccounts && rest.platformAccounts.length > 0){
        if(!rest.platformAccounts.find(p => `${p.id}` === `${ca}`)){
          setCurrentAccount(null)
        }
      }
      yield call(
        idendify,
        `${response.id}@t${response.tenant.id}-${snakeCase(response.tenant.name)}`,
      )
    }
  }catch (error) {
    setActiveTenant(null)
    yield call(mapAuthProviders[authProvider].logout)
  }

  yield put({
    type: 'user/SET_STATE',
    payload: {
      loading: false,
    },
  })
  yield put({
    type: 'menu/GET_DATA'
  })
}

export function* LOGOUT() {
  const { authProvider } = yield select(state => state.settings)
  setCurrentAccount(null)
  yield call(mapAuthProviders[authProvider].logout)
  yield put({
    type: 'user/SET_STATE',
    payload: {
      id: '',
      name: '',
      role: '',
      email: '',
      avatar: '',
      authorized: false,
      loading: false,
    },
  })
  yield call(resetSession)
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.REGISTER, REGISTER),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    // LOAD_CURRENT_ACCOUNT(), // run once on app load to check user auth
  ])
}
